import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import MenuAppBar from './MenuAppBar'
import About from './About'
import DebtPayoffCalc from './DebtPayoffCalc'

// change the default Mui Theme
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import amber from '@material-ui/core/colors/amber';

const theme = createMuiTheme({
    palette: {
        primary: amber
    },
});

//https://blog.logrocket.com/the-definitive-guide-to-react-material-d730c8a3e8ba/
export default function WBTeamMainRouter() {

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Router basename="/fincalcs">
                    <MenuAppBar></MenuAppBar>
                    <div>
                        <Switch>
                            <Route path="/about">
                                <About></About>
                            </Route>
                            <Route path="/calculators/debtpayoff">
                                <DebtPayoffCalc></DebtPayoffCalc>
                            </Route>
                            <Route path="/">
                                <h1>Home</h1>
                            </Route>
                        </Switch>
                    </div>
                </Router>
            </ThemeProvider>
        </div>
    );
}

